export default __webpack_public_path__ + "static/media/logomenu_w.f9db56f5.png";